import { Directive, input } from '@angular/core';

@Directive({
  selector: 'tt-button-group',
  standalone: true,
  host: {
    class: 'tt-button-group',
  },
})
export class ButtonGroupDirective {
  public disabled = input(false);
  public isBusy = input(false);
}
